// extracted by mini-css-extract-plugin
export default {"root":"Menu_root__qmpoN","list":"Menu_list__T5Ucq","item":"Menu_item__QwQKd"};